import React from 'react';
import { string, bool, array, func } from 'prop-types';
import styled, { css } from 'styled-components';
import { Text, IconContainer, Icon, Column } from '../../common';

const TableContainerWrapper = styled.div`
  height: 100%;
  display: flex;
  width: 100%;
  ${({ isMobile }) => isMobile && css`
    max-height: calc(100vh - 198px);
    th {
        position: sticky;
        top: 0;
        background-color: #ffffff;
        z-index: 1;
    }
  `}
`;

const TableContainer = ({
    title,
    data,
    headers,
    footer = [],
    className,
    renderItem,
    renderFooter,
    renderHeader,
    fetching,
    tableProps,
    isMobile
}) => {
    return (
        <TableContainerWrapper isMobile={isMobile}>
            { !data.length ? (
                <Column align='center' justify='center' mB={20}>
                    <IconContainer margin={20}>
                        <Icon name='cross' size={30} color='#ffffff' />
                    </IconContainer>
                    <Text size={14} text='No se han encontrado productos.' />
                </Column>
            ) : (
                <table {...tableProps}>
                    <thead>
                        <tr>{(headers).map(renderHeader)}</tr>
                    </thead>
                    <tfoot>
                        <tr>{(footer || headers).map(renderFooter)}</tr>
                    </tfoot>
                    <tbody>
                        {Object.values(data).map(renderItem)}
                    </tbody>
                </table>
            )}
        </TableContainerWrapper>
    );
};

TableContainer.propTypes = {
    className: string,
    data: array,
    fetching: bool,
    title: string,
    renderHeader: func,
    renderFooter: func,
    renderItem: func,
    headers: array,
    footer: array,
    isMobile: bool
};

TableContainer.defaultProps = {
    title: 'table',
    headers: [],
    footer: [],
    items: [],
    renderHeader: (header, key) => (<th className='header' key={`th-${key}`} >{header}</th>),
    renderFooter: (footerItem, key) => (<th key={`tf-${key}`}>{footerItem}</th>),
    renderItem: () => ([]),
    isMobile: false
};

export default TableContainer;
